interface FormValues {
  Name: string;
  Phone?: string;
  Email: string;
  Address: string;
  Message: string;
  PostalCode: string;
}

export const validate = (values: FormValues) => {
  const errors: Partial<FormValues> = {};

  // Validate Name
  if (!values.Name.trim()) {
    errors.Name = "Navn er påkrevd.";
  }

  // Validate Email
  if (!values.Email.trim()) {
    errors.Email = "E-post er påkrevd.";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.Email)) {
    errors.Email = "Vennligst oppgi en gyldig e-postadresse.";
  }

  // Validate Phone
  if (values.Phone && !/^\+?[0-9]{7,15}$/i.test(values.Phone)) {
    errors.Phone = "Telefonnummeret må være gyldig (8 siffer).";
  }

  // Validate Address
  if (!values.Address.trim()) {
    errors.Address = "Vennligst fyll inn addresse.";
  }

  // Validate Postal Code
  if (!values.PostalCode.trim()) {
    errors.PostalCode = "Vennligst fyll inn postnummer.";
  } else if (!/^[0-9]{4}$/i.test(values.PostalCode)) {
    errors.PostalCode = "Postnummeret må være gyldig (4 siffer).";
  }

  // Validate Message
  if (!values.Message.trim()) {
    errors.Message = "Vennligst skriv en melding.";
  }

  return errors;
};
